import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData,
  type DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError,
  type DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse,
  deleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete,
} from '../../generated';

export type DeleteImageFromCollectionMutationVariables =
  DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData['path'];

export type DeleteImageFromCollectionMutation =
  DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse;

export const useDeleteImageFromCollectionMutation = <
  TError = DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<DeleteImageFromCollectionMutation, TError, DeleteImageFromCollectionMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeleteImageFromCollectionMutation, TError, DeleteImageFromCollectionMutationVariables, TContext>({
    mutationKey: ['DeleteImageFromCollection'],
    mutationFn: async ({ portfolio_id, collection_id, image_id }: DeleteImageFromCollectionMutationVariables) => {
      const { data } =
        await deleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete({
          path: { portfolio_id, collection_id, image_id },
          throwOnError: true,
        });
      return data;
    },
    ...options,
  });
};

useDeleteImageFromCollectionMutation.fetcher = (
  { portfolio_id, collection_id, image_id }: DeleteImageFromCollectionMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } =
      await deleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete({
        path: { portfolio_id, collection_id, image_id },
        throwOnError: true,
      });
    return data;
  };
};
